import { APP_INITIALIZER, inject } from '@angular/core';
import { ConfigStateService, RoutesService } from '@abp/ng.core';
import { FLEET_SCORE_BASE_ROUTES } from './fleet-score-base.route';
import { addRoutesWhenAnyFeatureEnabled } from '../../shared/routes/feature-routes.util';

export const FLEET_SCORE_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);
  const configState = inject(ConfigStateService);

  return () => {
    addRoutesWhenAnyFeatureEnabled(
      routesService,
      configState,
      ['cargo_fleet.FleetScore'],
      [...FLEET_SCORE_BASE_ROUTES],
    );
  };
}
